import { render } from "./contestInformation.vue?vue&type=template&id=2f077226&scoped=true"
import script from "./contestInformation.vue?vue&type=script&lang=js"
export * from "./contestInformation.vue?vue&type=script&lang=js"

import "./contestInformation.vue?vue&type=style&index=0&id=2f077226&lang=less&scoped=true"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f077226"]])

export default __exports__